export const channel = new BroadcastChannel('cgf-torre-channel');
